import React from 'react';
import { Link } from 'react-router-dom';

import { ratioToPercent, round2 } from '../../lib/format';
import { FOUR_FACTORS, RATINGS } from '../../shared/constants';
import NoData from './NoData';
import Spinner from './Spinner';

/**
 */
const SummaryList = ({ title, items }) => {
  const hasData = !!items;
  const hasItems = hasData && items.length;
  return (
    <div className="summary-box">
      <p className="summary-box__title">{title}</p>
      {hasItems ? (
        items.map(item => <Item key={item.id} {...item} />)
      ) : hasData ? (
        <NoData text="No combinations found above 100 possessions" />
      ) : (
        <div className="summary-box__empty">
          <Spinner size="3" />
        </div>
      )}
    </div>
  );
};

export default SummaryList;

export const Item = ({ title, description, url, factors, ratings }) => {
  const summaryItem = SummaryItem({
    title,
    description,
    factors,
    ratings,
  });

  return url ? <Link to={url}> {summaryItem} </Link> : summaryItem;
};

const SummaryItem = ({ title, description, factors, ratings }) => (
  <div className="summary-box__item is-fade-loaded">
    <div className="summary-box__item-container">
      <p className="summary-box__item-title">{title}</p>
      <p className="summary-box__item-desc">{description}</p>
    </div>
    <div>{factors && <FourFactors factors={factors} />}</div>
    <div>{ratings && <Ratings ratings={ratings} />}</div>
  </div>
);

/**
 * Renders the right part of a summary (the four factors part)
 * @param {[{title, data}]} factors - an array of objects
 */
export const FourFactors = ({ factors }) => {
  return (
    <table className="four-factor">
      <tbody>
        <tr>
          <th />
          <th title="Effective Field Goal Rate">EFG</th>
          <th title="Offensive Rebound Rate">ORR</th>
          <th title="Free Throws Rate">FTR</th>
          <th title="Turnover Rate">TOV</th>
        </tr>

        {factors.map(({ title, data, name }) => (
          <tr key={title}>
            <th className="four-factor-team" title={title}>
              {name}
            </th>

            {FOUR_FACTORS.map(factor => (
              <td
                key={factor}
                className={data[factor].isBest ? 'highlight' : ''}
              >
                {ratioToPercent(data[factor].value)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const Ratings = ({ ratings }) => {
  return (
    <table className="four-factor">
      <thead>
        <tr>
          <th />
          <th title="Offensive Rating">OFF</th>
          <th title="Defensive Rating">DEF</th>
          <th title="Net Rating">NET</th>
        </tr>
      </thead>

      {ratings.map(({ title, data, name, category }) => (
        <tbody key={title}>
          <tr>
            <th className="four-factor-team" title={title}>
              {name}
            </th>

            {RATINGS.map(rating => (
              <td
                key={`${category}-${title}-${rating}`}
                className={data[rating].isBest ? 'highlight' : ''}
              >
                {round2(data[rating].value)}
              </td>
            ))}
          </tr>

          <tr>
            <th colSpan="4">
              Possessions:{' '}
              <span className="highlight">
                {round2(data['possessions'].value)}
              </span>
            </th>
          </tr>
        </tbody>
      ))}
    </table>
  );
};
